import React, { useContext, useState } from "react"
import { Link, Redirect } from "wouter"
import { AuthContext } from "../contexts/auth"
import { login } from "../services/api"
import { XCircleIcon, EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline"

export default function Login() {

  const [data, setData] = React.useState({ email: '', codice: '', password: ''});
  const [error, setError] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const onInputChange = (e) => {
    const { name, value } = e.target;

    setData(prev => ({
      ...prev,
      [name]: name === 'codice' ? value.replace(/\D/g, '') : value
    }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const { token, setToken, setProfile, setIsEmployee } = useContext(AuthContext)

  const validateForm = () => {
    if (!data.email || !data.codice || !data.password) {
      setError('Tutti i campi sono obbligatori.')
      return false;
    }
    return true;
  }

  const formSubmisison = (e) => {
    e.preventDefault()
    if (!validateForm()) return;
    
    setLoading(true)
    setError('')
    // setToken('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxMzE2MjM5MDIyLCJleHAiOjE5MTYyMzkwMjIsImNvbXBhbnlfaWQiOjIyNjN9.39fiXNuHNMjhclMTGyONy_bpVejgtGWCbWMC4p9SN10')
    login(data).then((res) => {
      setToken(res.token)
      setProfile(res)
      if (res.customer_type === 'employee'){
        setIsEmployee(true)
      }
      setLoading(false)
      // window.location.href = '/'
      // redirect with react-router to home
      
    }).catch((err) => {
      console.error("Errore durante il login:", err)
      if (err.response && err.response.data && err.response.data.error) {
        setError(err.response.data.error);
      } else {
        setError('Si è verificato un errore. Per favore, riprova.');
      }
      setLoading(false);
    });
  }

  if (token) {
    return <Redirect to="/" />
  }

  return (
    <>
      <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8" id="main_bg" style={{minHeight: '100vh'}}>
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-white">Accedi alla tua area riservata</h2>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <XCircleIcon className="h-5 w-5 text-red-400" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800">Si è verificato un errore</h3>
                  <div className="mt-2 text-sm text-red-700">
                    <ul role="list" className="list-disc space-y-1 pl-5">
                      <li>{error}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
            {!loading && (
            <form className="space-y-6" onSubmit={formSubmisison}>
              <div>
                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                  Email
                </label>
                <div className="mt-2">
                  <input
                    onChange={onInputChange}
                    id="email"
                    name="email"
                    value={data.email}
                    type="email"
                    autoComplete="email"
                    // required
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="codiceAzienda" className="block text-sm font-medium leading-6 text-gray-900">
                  Codice Azienda
                </label>
                <div className="mt-2">
                  <input
                    onChange={onInputChange}
                    id="codiceAzienda"
                    name="codice"
                    value={data.codice}
                    type="text"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    autoComplete="codiceAzienda"
                    // required
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                  Password
                </label>
                <div className="mt-2 relative">
                  <input
                    onChange={onInputChange}
                    id="password"
                    value={data.password}
                    name="password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="current-password"
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                  />
                  <button
                    type="button"
                    onClick={togglePasswordVisibility}
                    className="absolute inset-y-0 right-0 flex items-center pr-3"
                    aria-label={showPassword ? "Nascondi password" : "Mostra password"}
                  >
                    {showPassword ? (
                      <EyeSlashIcon className="h-5 w-5 text-gray-700 hover:text-gray-600" />
                    ) : (
                      <EyeIcon className="h-5 w-5 text-gray-700 hover:text-gray-600" />
                    )}
                  </button>
                </div>
              </div>

              <div className="flex items-center justify-between">
                {/* <div className="flex items-center">
                  <input
                    id="remember-me"
                    name="remember-me"
                    type="checkbox"
                    className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                  />
                  <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                    Remember me
                  </label>
                </div> */}

                {/* <div className="text-sm">
                  <a href="#" className="font-medium text-indigo-600 hover:text-indigo-500">
                    Password Dimenticata?
                  </a>
                </div> */}

                <div className="text-sm">
                  {/* <Link
                    to="/signup"
                    className="font-medium text-indigo-600 hover:text-indigo-500">
                    Non hai un account? Registralo
                  </Link> */}
                  <br />
                  <Link
                    to="/recover"
                    className="font-medium text-indigo-600 hover:text-indigo-500">
                    Non ricordi la password? Resettala
                  </Link>
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                >
                  Accedi
                </button>
                  
              </div>
            </form>
            )}

            {loading && (
              <div className="text-center">
              <div role="status">
                <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                  <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
                <span className="sr-only">Loading...</span>
              </div>
              </div>
            )}

            
          </div>
        </div>
      </div>
    </>
  )
}
